import _global3 from "../internals/global";
import _defineGlobalProperty from "../internals/define-global-property";
var exports = {};
var _global2 = _global3;
var defineGlobalProperty = _defineGlobalProperty;
var SHARED = "__core-js_shared__";
var store = _global2[SHARED] || defineGlobalProperty(SHARED, {});
exports = store;
export default exports;